var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHidden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24821 8.63851C9.60085 8.28587 10.1726 8.28587 10.5252 8.63851L23.1671 21.2804C23.5198 21.633 23.5198 22.2048 23.1671 22.5574C22.8145 22.9101 22.2427 22.9101 21.8901 22.5574L9.24821 9.91554C8.89557 9.5629 8.89557 8.99115 9.24821 8.63851Z",
    fill: "#808690"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_18511",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 19,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4462 20.8894C20.1036 20.8894 23.218 17.8779 24.3925 16.5773C24.6973 16.2398 24.6973 15.7414 24.3925 15.4039C23.218 14.1032 20.1036 11.0918 16.4462 11.0918C12.7887 11.0918 9.67437 14.1032 8.49984 15.4039C8.19507 15.7414 8.19507 16.2398 8.49984 16.5773C9.67437 17.8779 12.7887 20.8894 16.4462 20.8894Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4475 18.0315C17.0075 18.0315 17.5446 17.8165 17.9406 17.4337C18.3366 17.0509 18.559 16.5317 18.559 15.9904C18.559 15.449 18.3366 14.9299 17.9406 14.5471C17.5446 14.1643 17.0075 13.9492 16.4475 13.9492C15.8875 13.9492 15.3504 14.1643 14.9544 14.5471C14.5584 14.9299 14.3359 15.449 14.3359 15.9904C14.3359 16.5317 14.5584 17.0509 14.9544 17.4337C15.3504 17.8165 15.8875 18.0315 16.4475 18.0315Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_18511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60938 7C6.60938 6.44771 7.05709 6 7.60938 6H25.8802C26.4325 6 26.8802 6.44772 26.8802 7V24.5951C26.8802 25.1474 26.4325 25.5951 25.8802 25.5951H7.60938C7.05709 25.5951 6.60938 25.1474 6.60938 24.5951V7Z",
    fill: "#808690"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHidden);
export default __webpack_public_path__ + "static/media/icon_hidden.429c008510269246e6dda68f39d3968d.svg";
export { ForwardRef as ReactComponent };